export const boxShadow: string = '0 0 5px rgba(0,0,0,.3';
export const boxShadowNoTop: string = '0 15px 15px rgba(0,0,0,.3';
